import { useEffect, useState } from "react";
import { WifiOff } from "lucide-react";
import { inr, calcPreview } from "../lib/api";
import { listQueue, QUEUE_EVENT } from "../lib/offline";

// This month's wage estimate from saved attendance plus marks still waiting on this phone.
export const WageEstimate = ({ w, est }) => {
  const [pending, setPending] = useState({});
  useEffect(() => {
    if (!est) return undefined;
    const load = () => listQueue().then((items) => {
      const out = {};
      items.filter((i) => i.kind === "attendance" && i.data.date.startsWith(est.month))
        .forEach((i) => i.data.entries.forEach((e) => { if (e.worker_id === w.id && e.status !== i.data.base?.[w.id]) out[i.data.date] = e.status; }));
      setPending(out);
    }).catch(() => {});
    load();
    window.addEventListener(QUEUE_EVENT, load);
    return () => window.removeEventListener(QUEUE_EVENT, load);
  }, [est, w.id]);
  if (!est) return null;
  const today = new Date().toLocaleDateString("en-CA");
  const marks = Object.fromEntries(Object.entries({ ...est.marks, ...pending }).filter(([d]) => d <= today));
  const days = Object.values(marks).reduce((s, v) => s + (v === "P" ? 1 : v === "H" ? 0.5 : 0), 0);
  const gross = Math.round(days * est.rate * 100) / 100;
  const c = calcPreview(days, gross, gross);
  const n = Object.keys(pending).length;
  const label = new Date(`${est.month}-01`).toLocaleString("en-IN", { month: "long", year: "numeric" });
  const Tile = ({ k, v, id, strong }) => (
    <div className="rounded-lg border border-[#1F2A3E] bg-[#0B1017] p-3"><div className="text-[10px] uppercase tracking-widest text-slate-500">{k}</div>
      <div className={`font-mono mt-1 ${strong ? "text-[#00E599] text-base" : "text-sm"}`} data-testid={id}>{v}</div></div>);
  return (
    <div className="c-surface p-6 c-rise" data-testid="wage-estimate-card">
      <div className="flex justify-between items-center mb-1"><div className="c-eyebrow">Wage estimate · {label}</div></div>
      <p className="text-xs text-slate-500 mb-3">{days} day(s) × {inr(est.rate)} per day, from attendance saved on this phone. PF 12% and ESIC 0.75% taken off. Final pay comes from the payroll run.</p>
      <div className="grid grid-cols-2 gap-2">
        <Tile k="Days worked" v={days} id="wage-est-days" />
        <Tile k="Gross" v={inr(gross)} id="wage-est-gross" />
        <Tile k="PF + ESIC" v={inr(c.pf + c.ee)} id="wage-est-deductions" />
        <Tile k="Take-home" v={inr(c.net)} id="wage-est-net" strong />
      </div>
      {n > 0 && <p className="text-[11px] text-amber-300 mt-2 flex items-center gap-1.5" data-testid="wage-est-pending"><WifiOff size={11} />Includes {n} day(s) marked on this phone, not uploaded yet</p>}
    </div>);
};
